'use strict';

// Constants
const CONFIG = {
    CLASS: {
        FOOTER_ALERT: 'footer-alert',
        ALERT_SUCCESS: 'alert-success',
        ALERT_DANGER: 'alert-danger'
    }
};

/**
 * Displays an alert message to the user
 * @param {string} data - data returned from the server's ajax call. It requires a success (boolean) and a message (string) property.
 */
function displayFooterAlert(data) {
    // Variables
    var status;

    // Tests if the request status was successful
    if (data.success) {
        status = CONFIG.CLASS.ALERT_SUCCESS;
    } else {
        status = CONFIG.CLASS.ALERT_DANGER;
    }

    if ($(`.${CONFIG.CLASS.FOOTER_ALERT}`).length === 0) {
        $('body').append(`<div class="${CONFIG.CLASS.FOOTER_ALERT}"></div>`);
    }
    $(`.${CONFIG.CLASS.FOOTER_ALERT}`).append(`<div class="alert ${status} role="alert">${data.message}</div>`);
    setTimeout(function () {
        $(`.${CONFIG.CLASS.FOOTER_ALERT}`).remove();
    }, 3000);
}

module.exports = {
    displayFooterAlert: displayFooterAlert
};
